// extracted by mini-css-extract-plugin
module.exports = {"root":"MainMenuLI_root__1PJn9"};